//left in for ajax / anything else that
//is using jquery
var $body = $('.js-body');

const body = document.querySelector(".js-body");
    //   thisPage = body.dataset.page,
    //   site = body.dataset.site;

let width = window.innerWidth,
    height = window.innerHeight;
